import axios from 'util/axiosConfig';

export const fetchVisitsReportAPI = async (params) => {

    let modifiedParams = {
        ...params,
        "filterRequest": {
            ...params.filterRequest,
            page: params.filterRequest.page - 1
        }
    }

    return await axios.post(`/api/v1/visits-report`, modifiedParams)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const fetchPaymentsReportAPI = async (params) => {

    let modifiedParams = {
        ...params,
        "filterRequest": {
            ...params.filterRequest,
            page: params.filterRequest.page - 1
        }
    }

    return await axios.post(`/api/v1/payment-report`, modifiedParams)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

